import { render, staticRenderFns } from "./AffiliateLinksPage.vue?vue&type=template&id=32795ca0&"
import script from "./AffiliateLinksPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports